import styled from 'styled-components'

import {
  backgroundTypes,
  borderTypes,
  boxModelTypes,
  cssTypes,
  displayTypes,
  positionTypes,
  transitionTypes,
} from '../types'
import {
  background,
  border,
  boxModel,
  css,
  display,
  position,
  transition,
} from '../util'

/**
 * @namespace Div
 * @desc Primitive styled-component 💅
 * @return {Function} React component
 */
const Div = styled.div`
  ${background};
  ${border};
  ${boxModel};
  ${css};
  ${display};
  ${position};
  ${transition};
`

/**
 * @name defaultProps
 * @memberof Div
 * @desc Primitive's default properties
 */
Div.defaultProps = {
  borderWidth: [0],
  margin: [0],
  padding: [0],
  size: ['auto'],
}

/**
 * @name propTypes
 * @memberof Div
 * @desc Primitive's prop type definitions
 */
Div.propTypes = {
  ...backgroundTypes,
  ...borderTypes,
  ...boxModelTypes,
  ...cssTypes,
  ...displayTypes,
  ...positionTypes,
  ...transitionTypes,
}

/** @component */
export default Div
